/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import parkplusStoreV2RedirectionRoutes from '../../../constants/parkplusStoreV2RedirectionRoutes';
import useParkplusStoreV2 from '../../../hooks/useParkplusStoreV2';
import { trackPopupViewStoreV2 } from '../../../utils/events';
import StackImages from '../../StackImages';
import s from './ChangedPricePopup.module.scss';
import { Button } from 'ui-v2/components/Button';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import Odometer from "core-lib/components/Odometer"

const PriceChangingCartId = '__price_changing_cart_id';

export const ChangedPricePopup = () => {
  // declarations
  const router = useRouter();

  // custom hooks
  const { cartData } = useParkplusStoreV2();

  // constants
  const { cartId, hasPriceChanged, newCartPrice, oldCartPrice } =
    cartData || {};
  const isIncreased = newCartPrice > oldCartPrice;

  // state
  const [show, setShow] = useState(false);

  const onClose = () => {
    setShow(false);
  };

  const showPriceChange = () => {
    const item = sessionStorage.getItem(PriceChangingCartId);
    if (cartId != item) {
      setShow(true);
      sessionStorage.setItem(PriceChangingCartId, cartId);
    }
  };

  useEffect(() => {
    if (hasPriceChanged) {
      showPriceChange();
    }
  }, [cartData]);

  useEffect(() => {
    if (show) {
      trackPopupViewStoreV2('price_change');
    }
  }, [show]);

  return (
    <Modal
      show={show}
      head={{
        show: true,
        onClose,
      }}
      rootStyle={{
        zIndex: 12,
      }}
      noPadding
    >
      <div className={s.root}>
        {!isIncreased && (
          <Typography
            label="Hurray!"
            variant="h_2_bold"
            className={s.hurray}
            style={{
              marginBottom: '16px',
            }}
          />
        )}
        <Typography
          label={`Your total price has ${isIncreased ? 'changed' : 'reduced'}`}
          variant="body_2_medium"
        />
        <Typography
          label={
            isIncreased
              ? 'due to insufficient Park+ Petrol balance'
              : 'as you have earned Park+ Petrol'
          }
          variant="body_3_medium"
          color="secondary"
          style={{
            marginBottom: '16px',
          }}
        />
        <div className={s.blur} />
        <div className={s.price}>
          <Typography
            label="₹"
            variant="h_2_bold"
            className={s.rupeesIcon}
            color={isIncreased ? 'primary' : 'positive'}
          />

          <Odometer
            initialValue={oldCartPrice}
            finalValue={newCartPrice}
            duration={1500}
            textVariant="h_2_bold"
            textColor={isIncreased ? 'primary' : 'positive'}
          />
        </div>
        <div className={s.blur} />

        {cartData?.data?.length && (
          <div className={s.stackImages}>
            <StackImages cartData={cartData?.data} size="large" />
          </div>
        )}

        <Button
          label="View items in cart"
          variant="link_color"
          size="medium"
          fullWidth
          onClick={() => router.push(parkplusStoreV2RedirectionRoutes.cart)}
        />
        <div className={s.btnwrap}>
          <Button
            label="Continue with updated price"
            fullWidth
            variant="primary"
            onClick={onClose}
            size="medium"
          />
        </div>
      </div>
    </Modal>
  );
};
